import { ReactNode, useRef } from "react";
import ApplicationLayout from "@rio-cloud/rio-uikit/ApplicationLayout";
import AppHeader from "../../features/header/AppHeader";
import { AppContext } from "../../layout/AppContext";

interface BackofficeLayoutProps {
  children: ReactNode;
}

const BackofficeLayout = ({ children }: BackofficeLayoutProps) => {
  const sidebarRef = useRef<HTMLDivElement>(null);

  return (
    <AppContext.Provider value={{ sidebarRef }}>
      <ApplicationLayout className="MyServiceLayout bg-lighter height-500">
        <ApplicationLayout.Header>
          <AppHeader
            navItems={[
              {
                key: "backoffice/consultants",
                value: "Consultores",
              },
              {
                key: "backoffice/failures",
                value: "Literatura técnica",
              },
              {
                key: "backoffice/steps",
                value: "Etapas de Ocorrência",
              },
            ]}
          />
        </ApplicationLayout.Header>
        <ApplicationLayout.Body className="uikitDemo">
          {children}
        </ApplicationLayout.Body>
      </ApplicationLayout>
    </AppContext.Provider>
  );
};

export default BackofficeLayout;
